import {Component, inject} from '@angular/core';
import {MaterialModule} from '../../material.module';
import {ClientPreparationService} from '../../services/objects/client-preparation.service';

@Component({
    selector: 'app-client-preparation-status',
    imports: [MaterialModule],
    template: `
      @if (preparation.state(); as state) {
        <section class="preparation-status" role="status" aria-live="polite" [attr.aria-busy]="state.running">
          @if (state.running) {
            <mat-spinner [diameter]="20" aria-label="Preparing local client"></mat-spinner>
            <span>Preparing local configuration and missing data… Document publishing can take several minutes. Existing local edits are preserved.</span>
          } @else if (state.result?.ready) {
            <mat-icon aria-hidden="true">check_circle</mat-icon>
            <span>Local configuration checked. Added {{ state.result?.added }} missing records; existing settings preserved.</span>
          } @else {
            <mat-icon aria-hidden="true">info</mat-icon>
            <div>
              <strong>Local setup needs attention</strong>
              <p>This check covers all chatbots and assistants for the selected client.</p>
              @if (state.error) { <p>{{ state.error }}</p> }
              @if (state.result?.issues?.length) {
                <details>
                  <summary>{{ state.result?.issues?.length }} items to complete before testing</summary>
                  <ul>
                    @for (issue of state.result?.issues; track $index) {
                      <li>{{ issue.resourceName || issue.resourceId || issue.resourceType }}: {{ issue.message }}</li>
                    }
                  </ul>
                </details>
              }
            </div>
            <button mat-stroked-button type="button" (click)="preparation.retry()">Check again</button>
          }
        </section>
      }
    `,
    styles: [`
      .preparation-status { display: flex; align-items: flex-start; gap: 12px; padding: 12px 20px;
        font-size: 14px; background: #f3f0ff; color: #302451; border-bottom: 1px solid #ded5f7; }
      mat-icon, mat-spinner { flex-shrink: 0; }
      p { margin: 4px 0; }
      details { margin-top: 4px; overflow-wrap: anywhere; }
      summary { cursor: pointer; }
      button { margin-left: auto; flex-shrink: 0; }
      @media(max-width: 600px) { .preparation-status { flex-wrap: wrap; } }
    `]
})
export class ClientPreparationStatusComponent {
    readonly preparation = inject(ClientPreparationService);
}
